import React from 'react'
import { Grid, Dropdown, Menu, Input, Header } from 'semantic-ui-react'
import {
  Link
} from "react-router-dom";

import { logout } from '../utils/requestHandler'

const onLogout = () => {
  logout()
  window.location.reload()
}

const NavigationBar = ({ applicationname }) => {
  return (
    <>
      <Menu>
        <Menu.Item>
          <Header as='h4'>
            {`${applicationname}`}
          </Header>
        </Menu.Item>

        <Menu.Menu position='right'>
          <Menu.Item>
            <Dropdown text={`${localStorage.getItem('username')}`}>
              <Dropdown.Menu>
                <Dropdown.Item text='Hem' as={Link} to='/' />
                <Dropdown.Item text='Om' as={Link} to='/about' />
                <Dropdown.Divider />
                <Dropdown.Item text='Användaradministration' as={Link} to='/useradministration' />
                <Dropdown.Divider />
                <Dropdown.Item text={`Logga ut ${localStorage.getItem('username')}`} onClick={(e, data) => { onLogout() }} />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </>
  )
}

export default NavigationBar;



